exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\n\tVARIABLES.SCSS\n\t-----------\n\tContains Media Queries, Colors, Variables\n\n\t@import 'src/scss/_variables.scss';\n*/\n.application {\n  /* give the outermost container a predefined size */\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n.application > .wrapper {\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    min-height: 0; }\n.application > .wrapper .navigation {\n      background-color: #FFF; }\n.application > .wrapper .views {\n      -webkit-box-flex: 1;\n          -ms-flex-positive: 1;\n              flex-grow: 1;\n      overflow: auto;\n      min-height: 0;\n      -ms-touch-action: pan-x pan-y;\n          touch-action: pan-x pan-y; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = main